// extracted by mini-css-extract-plugin
export default {"addToProjectModal":"css_addToProjectModal__hh0h4","title":"css_title__x+ENk","selectsList":"css_selectsList__9174f","buttons":"css_buttons__HBXFr"};